const date = new Date();

export const todaysDate = date.toLocaleDateString('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric'
}).replace(/ /g, '-');

export const pagination = {
  page: 1,
  limit: 10,
  maxlimit: 10000,
  scrollLimit: 12,
};

export const PaginationOption = [
  10, 15, 20, 25
];

export const Status = [
  { label: "Inactive", value: "0" },
  { label: "Active", value: "1" },
];

export const Priority = [
  { label: "Standard", value: "0" },
  { label: "Emergency", value: "1" },
];